module.exports = __webpack_public_path__ + "static/media/cat1.6b7f44dd.png";